// Authentication
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const ACTIVATION_FAIL = 'ACTIVATION_FAIL';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const REMOVE_AUTH_LOADING = 'REMOVE_AUTH_LOADING';
export const AUTHENTICATED_SUCCESS = 'AUTHENTICATED_SUCCESS';
export const AUTHENTICATED_FAIL = 'AUTHENTICATED_FAIL';
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS';
export const REFRESH_FAIL = 'REFRESH_FAIL';
export const LOGOUT = 'LOGOUT';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const RESET_PASSWORD_CONFIRM_SUCCESS = 'RESET_PASSWORD_CONFIRM_SUCCESS';
export const RESET_PASSWORD_CONFIRM_FAIL = 'RESET_PASSWORD_CONFIRM_FAIL';

// Tarifas
export const SET_TARIFA_OFERTA_SUCCESS = 'SET_TARIFA_OFERTA_SUCCESS';

//Contratos
export const GET_CONTRATOS_SUCCESS = 'GET_CONTRATOS_SUCCESS';
export const GET_CONTRATOS_FAIL = 'GET_CONTRATOS_FAIL';
export const CONTRATO_SUCCESS = 'CONTRATO_SUCCESS';
export const CONTRATO_FAIL = 'CONTRATO_FAIL';

//Auxiliares
export const GET_PROVINCIA_SUCCESS = 'GET_PROVINCIA_SUCCESS';
export const GET_MUNICIPIO_SUCCESS = 'GET_MUNICIPIO_SUCCESS';
export const GET_POBLACION_SUCCESS = 'GET_POBLACION_SUCCESS';
export const GET_TIPOVIA_SUCCESS = 'GET_TIPOVIA_SUCCESS';
export const GET_PAIS_SUCCESS = 'GET_PAIS_SUCCESS';
export const GET_DISTRIBUIDORAS_GAS_SUCCESS = 'GET_DISTRIBUIDORAS_GAS_SUCCESS';
export const GET_CNAES_SUCCESS = 'GET_CNAES_SUCCESS';

//Loader
export const SET_LOADER = 'SET_LOADER';
export const REMOVE_LOADER = 'REMOVE_LOADER';
